import IllustratorLogin from "../../Assets/Illustrator-login.png";
import { FaEnvelope, FaLock } from "react-icons/fa";
import { motion } from "framer-motion";
import { useState, useEffect } from "react";
import Cookies from "js-cookie";
import {
	VerifyUser,
	VerifyMfaOtp,
	RegisterMfa,
} from "../../Services/LoginService";
import {
	useNavigate,
	useSearchParams,
	useParams,
	useLocation,
} from "react-router-dom";

const CentralizedLoginPage = () => {
	const navigate = useNavigate();
	const { appId } = useParams();
	const [searchParams] = useSearchParams();
	const location = useLocation();

	const [step, setStep] = useState("LOGIN");
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [otp, setOtp] = useState("");
	const [qrCode, setQrCode] = useState("");
	const [mfaSecret, setMfaSecret] = useState("");
	const [tempToken, setTempToken] = useState("");
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState("");
	const [userUID, setUserUID] = useState("");
	const callbackURL = searchParams.get("callbackURL");

	const handleLogin = async (e) => {
		e.preventDefault();
		setError("");
		setLoading(true);

		try {
			const res = await VerifyUser({
				appKey: appId,
				email,
				password,
			});

			if (res.status === "Success") {
				const { mfaEnabled, mfaSecret, qrCode, tempToken } = res.userDetails;

				setTempToken(tempToken);
				setUserUID(res.userDetails.userUID);
				if (mfaEnabled) {
					setStep("OTP");
				} else {
					setMfaSecret(mfaSecret);
					setQrCode(qrCode);
					setStep("REGISTER_MFA");
					setQrCode(res.qrCode);
				}
			} else {
				setError(res.message || "Login failed");
			}
		} catch (err) {
			setError("Invalid email or password");
		} finally {
			setLoading(false);
		}
	};

	const handleVerifyOtp = async () => {
		setError("");
		setLoading(true);

		try {
			// const res = await VerifyMfaOtp({
			// 	appID: appId,
			// 	userUID,
			// 	otp,
			// 	callbackURL: callbackURL,
			// });

			const res = await VerifyMfaOtp(
				{
					userUID,
					otp,
					callbackURL: callbackURL,
				},
				appId
			);

			if (res.status === "Success") {
				if (res.callbackURL) {
					window.location.href = res.callbackURL;
					return;
				} else {
					navigate("/dashboard");
				}
			} else {
				setError(res.message || "Invalid OTP");
			}
		} catch {
			setError("OTP verification failed");
		} finally {
			setLoading(false);
		}
	};

	const handleRegisterMfa = async () => {
		setError("");

		try {
			//   const res = await RegisterMfa({
			//     appID: appId,
			//     userUID,
			//     mfaSecret,
			//     otp,
			//   });
			const res = await RegisterMfa(
				{
					userUID,
					mfaSecret,
					otp,
				},
				appId
			);

			if (res.status === "Success") {
				sessionStorage.setItem("UserUID", res.userUID);
				navigate("/dashboard");
			} else {
				setError(res.message);
			}
		} catch {
			setError("MFA registration failed");
		}
	};
	useEffect(() => {
		if (callbackURL) {
			sessionStorage.setItem("callbackURL", callbackURL);

			const cleanUrl = location.pathname;
			window.history.replaceState({}, "", cleanUrl);
		}
	}, []);

	return (
		<div className="min-h-screen flex bg-gradient-to-br from-blue-50 to-white">
			{/* LEFT SECTION */}
			<div className="flex-1 flex justify-center items-center p-8">
				<div className="w-full max-w-md bg-white p-10 rounded-3xl shadow-xl">
					{/* LOGO */}
					<div className="text-center mb-6">
						<img
							src="https://www.vrsamadhantech.com/images/logo_home.png"
							alt="Logo"
							className="w-24 mx-auto"
						/>
						<h2 className="text-2xl font-bold text-blue-900 mt-3">
							Centralized Login
						</h2>
					</div>

					{/* ERROR */}
					{error && (
						<p className="text-red-500 text-sm text-center mb-4">{error}</p>
					)}

					{/* LOGIN STEP */}
					{step === "LOGIN" && (
						<form onSubmit={handleLogin} className="space-y-4">
							<div className="relative">
								<FaEnvelope className="absolute left-3 top-3 text-gray-400" />
								<input
									type="email"
									placeholder="Email"
									className="w-full pl-10 py-2 border rounded-lg"
									value={email}
									onChange={(e) => setEmail(e.target.value)}
								/>
							</div>

							<div className="relative">
								<FaLock className="absolute left-3 top-3 text-gray-400" />
								<input
									type="password"
									placeholder="Password"
									className="w-full pl-10 py-2 border rounded-lg"
									value={password}
									onChange={(e) => setPassword(e.target.value)}
								/>
							</div>

							<button
								type="submit"
								disabled={loading}
								className="w-full bg-blue-700 text-white py-2 rounded-lg hover:bg-blue-800"
							>
								{loading ? "Signing in..." : "Login"}
							</button>
						</form>
					)}

					{/* OTP STEP */}
					{step === "OTP" && (
						<div className="space-y-4">
							<p className="text-sm text-gray-600 text-center">
								Enter OTP from Authenticator
							</p>

							<input
								type="text"
								placeholder="6-digit OTP"
								className="w-full py-2 border rounded-lg text-center tracking-widest"
								value={otp}
								onChange={(e) => setOtp(e.target.value)}
							/>

							<button
								onClick={handleVerifyOtp}
								className="w-full bg-green-600 text-white py-2 rounded-lg hover:bg-green-700"
							>
								Verify OTP
							</button>
						</div>
					)}

					{/* REGISTER MFA STEP */}
					{step === "REGISTER_MFA" && (
						<div className="space-y-4 text-center">
							<p className="text-sm text-gray-600">
								Scan QR with Google Authenticator
							</p>

							{qrCode && (
								<img src={qrCode} alt="MFA QR" className="mx-auto w-40" />
							)}

							<input
								type="text"
								placeholder="Enter OTP"
								className="w-full py-2 border rounded-lg text-center"
								value={otp}
								onChange={(e) => setOtp(e.target.value)}
							/>

							<button
								onClick={handleRegisterMfa}
								className="w-full bg-purple-700 text-white py-2 rounded-lg hover:bg-purple-800"
							>
								Confirm & Enable MFA
							</button>
						</div>
					)}

					<p className="text-xs text-gray-500 text-center mt-6">
						Designed & Developed by <b>VRSamadhan Tech Solution</b>
					</p>
				</div>
			</div>

			{/* RIGHT SECTION */}
			<div className="hidden md:flex flex-1 items-center justify-center bg-blue-800 text-white">
				<div className="text-center space-y-4">
					<h2 className="text-3xl font-bold">Secure Login</h2>
					<p className="text-blue-200">
						One account. Multiple dashboards. Fully protected.
					</p>
					<img
						src={IllustratorLogin}
						alt="Illustration"
						className="w-[420px] mx-auto"
					/>
				</div>
			</div>
		</div>
	);
};

export default CentralizedLoginPage;
